import { render, staticRenderFns } from "./failed_jobs_table.vue?vue&type=template&id=f4c1c324&scoped=true&"
import script from "./failed_jobs_table.vue?vue&type=script&lang=js&"
export * from "./failed_jobs_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c1c324",
  null
  
)

export default component.exports